export const parseCurrencyString = (value) => {
    if (!value)
        return '0';
    return value.replace(/[$,]/g, '');
};
export const getDecimalPlaces = (coinSymbol) => {
    const highPriceCoins = ['WBTC', 'WETH', 'LBTC', 'TBTC', 'XBTC', 'EBTC', 'SUIBTC', 'XAUM'];
    return highPriceCoins.includes(coinSymbol.toUpperCase()) ? 6 : 5;
};
export const commaFy = (num) => {
    const str = num.toString().split('.');
    if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }
    return str.join('.');
};
